module.exports = __webpack_public_path__ + "static/media/jutlo.3a85b7c6.svg";